module.exports = __webpack_public_path__ + "b073f5972d9c4cc1b8ae8e071e441376.woff2";